module.exports = __webpack_public_path__ + "img/36.aa6e7e34.jpg";